import {useSyncedPollingPublisher} from './hooks';

export const SyncedPollingPublisher = () => {
  useSyncedPollingPublisher();
  return null;
};
